/**
 * Returns a step corresponding to the unit.
 * @param  {Object[]} steps
 * @param  {string} unit
 * @return {?Object}
 */
export function getStepForUnit(steps, unit) {
  for (var _iterator = steps, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var step = _ref;

    if (step.unit === unit) {
      return step;
    }
  }
}
/**
 * Converts value to a `Date`
 * @param {(number|Date)} value
 * @return {Date}
 */

export function getDate(value) {
  return value instanceof Date ? value : new Date(value);
}